<h2
  mat-dialog-title
  [ngStyle]="{
    color: data.filterSettings.textColor,
    background: data.filterSettings.backgroundColor
  }"
>
  {{ 'COMMON.LOCATION' | translate }}
</h2>

<mat-dialog-content class="account-selection-container">
  <div class="search-container">
    <mat-form-field appearance="outline">
      <input
        type="text"
        matInput
        placeholder="{{ 'BRANDS.LISTINGS.SEARCH_FOR_LOCATION' | translate }}"
        [formControl]="accountGroupFilterControl"
        autocomplete="off"
      />
    </mat-form-field>
    <cdk-virtual-scroll-viewport itemSize="57" minBufferPx="500px" maxBufferPx="500px" class="available-options">
      @if (filteredOptions$ | async; as options) {
        @if (noResultsFound && !!accountGroupFilterControl.value && accountGroupFilterControl.value.trim() !== '') {
          <div class="no-results-found">
            {{ 'BRANDS.LOCATIONS_MODAL.NO_RESULTS' | translate }}
          </div>
        }
        <div #optionEl class="option" *cdkVirtualFor="let option of options">
          <div class="option-details">
            <div class="address-option-container">
              <div class="name">{{ option.name }}</div>
              <div class="address">{{ option.address }}</div>
            </div>
          </div>
          <div class="option-actions">
            <button color="primary" mat-icon-button (click)="selectFilterLocation(optionEl, option.accountGroupId)">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      }
    </cdk-virtual-scroll-viewport>
  </div>
  <div class="selection-container">
    @if (selectedOptionsDetails$ | async; as options) {
      <div class="title">
        <span>
          {{ 'BRANDS.LOCATIONS_MODAL.SELECTED_LOCATIONS' | translate }}
        </span>
        @if (options.length > 0) {
          <span>
            ({{ options.length }} {{ (options.length === 1 ? 'COMMON.LOCATION' : 'COMMON.LOCATIONS') | translate }})
          </span>
        }
      </div>
      <div class="options-container">
        @if (options.length === 0) {
          <div class="no-results-found">
            {{ 'BRANDS.LOCATIONS_MODAL.NO_LOCATIONS' | translate }}
          </div>
        }
        @for (item of options; track item) {
          <mat-card appearance="outlined">
            <div class="address-option-container">
              <div class="name">{{ item.name }}</div>
              <div class="address">{{ item.address }}</div>
            </div>
            <div class="action">
              <mat-icon (click)="removeLocation(item.accountGroupId)">cancel</mat-icon>
            </div>
          </mat-card>
        }
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close(false)">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="close(true)">
    {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
